<div class="loader-body" *ngIf="loader">
    <div class="loader">
        <div>
            <ul>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
            </ul>
        </div><span>{{'loading' | translate}}</span>
    </div>
</div>

<section *ngIf="!loader">
    <!-- Start Banner Area -->
    <div class="rbt-banner-area rbt-banner-1 variation-2 height-750">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col-lg-8">
                    <div class="content">
                        <div class="inner">
                            <div class="rbt-new-badge rbt-new-badge-one">
                                <span class="rbt-new-badge-icon">🏆</span> {{'The Leader in Online Learning' | translate}}
                            </div>
                            <h1 class="title"><span class="color-primary">{{'platform' | translate}}</span>
                                 {{'thatIncludes' | translate}}</h1>
                            <p class="description">
                                {{'Explore' | translate}}
                            </p>
                            <div class="slider-btn">
                                <a class="rbt-btn btn-gradient hover-transform-none" routerLink="/courses">
                                    <span class="icon-reverse-wrapper">
                                        <span class="btn-text">{{'View Course' | translate}}</span>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 sliderCon">
                    <div class="content">
                        <div class="banner-card pb--60 swiper rbt-dot-bottom-center banner-swiper-active">
                            <div class="swiper-wrapper">
                                <!-- Start Single Card  -->
                                <div class="swiper-slide">
                                    <div class="rbt-card variation-01 rbt-hover">
                                        <div class="rbt-card-img">
                                            <a>
                                                <img style="max-height: 220px;min-height: 220px;" [src]="this.baseService.appUrl + topRatedCourse[0]?.thumbNail" onerror=" this.onerror=null;this.src='assets/images/bg/bg-g100.webp';" alt="Card image">
                                                <div class="rbt-badge-3 bg-white">
                                                    <span>{{'Top' | translate}}</span>
                                                    <span>{{'rated' | translate}}</span>
                                                </div>
                                            </a>
                                        </div>
                                        <div class="rbt-card-body">
                                            <ul class="rbt-meta">
                                                <li>{{this.topRatedCourse[0]?.lessons}} {{'Lessons' | translate}}</li>
                                                <li>{{this.topRatedCourse[0]?.studentsNo}} {{'Students' | translate}}</li>
                                            </ul>
                                            <h4 class="rbt-card-title"><a>{{this.topRatedCourse[0]?.courseNameAr}}</a>
                                            </h4>
                                            <p class="rbt-card-text">{{this.topRatedCourse[0]?.summary}}</p>
                                            <div class="rbt-review">
                                                <div class="rating" *ngIf="this.topRatedCourse[0]?.rating === 5">
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                </div>
                                                <div class="rating" *ngIf="this.topRatedCourse[0]?.rating > 4 && this.topRatedCourse[0]?.rating < 5">
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                                </div>
                                                <div class="rating" *ngIf="this.topRatedCourse[0]?.rating > 3 && this.topRatedCourse[0]?.rating < 4">
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                                    <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                                </div>
                                                <div class="rating" *ngIf="this.topRatedCourse[0]?.rating > 2 && this.topRatedCourse[0]?.rating < 3">
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                                    <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                                    <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                                </div>
                                                <div class="rating" *ngIf="this.topRatedCourse[0]?.rating > 1 && this.topRatedCourse[0]?.rating < 2">
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                                    <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                                    <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                                    <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                                </div>
                                                <div class="rating" *ngIf="this.topRatedCourse[0]?.rating < 1">
                                                    <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                                    <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                                    <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                                    <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                                    <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                                </div>
                                            </div>
                                            <div class="rbt-card-bottom">
                                                <div class="rbt-price" *ngIf="this.topRatedCourse[0]?.price === 0">
                                                    <span class="current-price">{{'Free' | translate}}</span>
                                                </div>
                                                <div class="rbt-price" *ngIf="this.topRatedCourse[0]?.price > this.topRatedCourse[0]?.offerPrice">
                                                    <span class="current-price">{{this.topRatedCourse[0]?.offerPrice}} {{'SAR' | translate}}</span>
                                                    <span class="off-price">{{this.topRatedCourse[0]?.price}} {{'SAR' | translate}}</span>
                                                </div>
                                                <div class="rbt-price" *ngIf="this.topRatedCourse[0]?.offerPrice > this.topRatedCourse[0]?.price">
                                                    <span class="current-price">{{this.topRatedCourse[0]?.price}} {{'SAR' | translate}}</span>
                                                </div>
                                                <a class="rbt-btn-link"  (click)="openDetail(this.topRatedCourse[0]?.id)">{{'LearnMore' | translate}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Single Card  -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Banner Area -->

    <!-- Start Course Area -->
    <div class="rbt-course-area rbt-section-gap">
        <div class="container">
            <div class="row mb--60">
                <div class="col-lg-12">
                    <div class="section-title text-center">
                        <span class="subtitle bg-primary-opacity">{{'TopPopularCourse' | translate}}</span>
                        <h2 class="title">{{'LearnyHomeCoursestudent' | translate}} <br /> {{'uCanJoinNow' | translate}}</h2>
                    </div>
                </div>
            </div>
            <!-- Start Card Area -->
            <div class="row g-5" style="justify-content: center;">
                <!-- Start Single Course  -->
                <div class="col-lg-3 col-md-6 col-12" *ngFor="let course of topRatedCourse">
                    <div class="rbt-card variation-01 rbt-hover" >
                        <div class="rbt-card-img">
                            <a>
                                <img style="max-height: 220px;min-height: 220px;" [src]="this.baseService.appUrl + course.thumbNail" onerror=" this.onerror=null;this.src='assets/images/bg/bg-g100.webp';" alt="Card image">
                                <!-- <div class="rbt-badge-3 bg-white">
                                    <span>-50%</span>
                                    <span>{{'Off' | translate}}</span>
                                </div> -->
                            </a>
                        </div>
                        <div class="rbt-card-body">

                            <div class="rbt-card-top">
                                <div class="rbt-review">
                                    <div class="rating" *ngIf="course.rating === 5">
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                    </div>
                                    <div class="rating" *ngIf="course.rating > 4 && course.rating < 5">
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                    </div>
                                    <div class="rating" *ngIf="course.rating > 3 && course.rating < 4">
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                        <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                    </div>
                                    <div class="rating" *ngIf="course.rating > 2 && course.rating < 3">
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                        <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                        <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                    </div>
                                    <div class="rating" *ngIf="course.rating > 1 && course.rating < 2">
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                        <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                        <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                        <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                    </div>
                                    <div class="rating" *ngIf="course.rating < 1">
                                        <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                        <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                        <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                        <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                        <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                    </div>
                                </div>
                                <!-- <div class="rbt-bookmark-btn">
                                    <a class="rbt-round-btn" title="Bookmark"><i class="feather-bookmark"></i></a>
                                </div> -->
                            </div>

                            <h4 class="rbt-card-title"><a>{{course.courseNameAr}}</a>
                            </h4>
                            <ul class="rbt-meta">
                                <li>{{course.lessons}} {{'Lessons' | translate}}</li>
                                <li>{{course.studentsNo}} {{'Students' | translate}}</li>
                            </ul>
                            <p class="rbt-card-text">{{course.summary}}</p>
                            <div class="rbt-author-meta mb--20">
                                <div class="rbt-avater">
                                    <a>
                                        <img [src]="this.baseService.appUrl + this.course.teacherProfileImg" onerror=" this.onerror=null;this.src='assets/images/client/avatar.png';" alt="Sophia Jaymes">
                                    </a>
                                </div>
                                <div class="rbt-author-info">
                                    {{'By' | translate}} <a>{{course.teacherName}}  {{course.teacherSurName}}</a> {{'in' | translate}} {{course.categoryNameAr}}
                                </div>
                            </div>

                            <div class="rbt-card-bottom">
                                <div class="rbt-price" *ngIf="course.price === 0">
                                    <span class="current-price">{{'Free' | translate}}</span>
                                </div>
                                <div class="rbt-price" *ngIf="course.price > course.offerPrice">
                                    <span class="current-price">{{course.offerPrice}} {{'SAR' | translate}}</span>
                                    <span class="off-price">{{course.price}} {{'SAR' | translate}}</span>
                                </div>
                                <div class="rbt-price" *ngIf="course.offerPrice > course.price">
                                    <span class="current-price">{{course.price}} {{'SAR' | translate}}</span>
                                </div>
                                <a class="rbt-btn-link" (click)="openDetail(course.id)">{{'LearnMore' | translate}}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Single Course  -->
            </div>
            <!-- End Card Area -->

            <div class="row">
                <div class="col-lg-12">
                    <div class="load-more-btn mt--60 text-center">
                        <a class="rbt-btn btn-gradient hover-transform-none" routerLink="/courses">
                            <span class="icon-reverse-wrapper">
                                <span class="btn-text">{{'LoadMoreCourse' | translate}}</span>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Course Area -->

    <!-- Start About Area  -->
    <div class="rbt-about-area bg-color-white rbt-section-gapTop pb_md--80 pb_sm--80 about-style-1">
        <div class="container">
            <div class="row g-5 align-items-center">
                <div class="col-lg-6">
                    <div class="thumbnail-wrapper">
                        <div class="thumbnail image-1">
                            <img data-parallax='{"x": 0, "y": -20}' src="assets/images/about/about-01AR.png"
                                alt="Education Images">
                        </div>
                        <div class="thumbnail image-2 d-none d-xl-block">
                            <img data-parallax='{"x": 0, "y": 60}' src="assets/images/about/about-02AR.png"
                                alt="Education Images">
                        </div>
                        <div class="thumbnail image-3 d-none d-md-block">
                            <img data-parallax='{"x": 0, "y": 80}' src="assets/images/about/about-03AR.png"
                                alt="Education Images">
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="inner pl--50 pl_sm--0 pl_md--0">
                        <div class="section-title text-start">
                            <span class="subtitle bg-coral-opacity">{{'Know About Us' | translate}}</span>
                            <h2 class="title">{{'Know About Learny Home' | translate}} <br /> {{'Learning Platform' | translate}}</h2>
                        </div>

                        <p class="description mt--30">{{'learnyHomeProvides' | translate}}</p>

                        <!-- Start Feature List  -->

                        <div class="rbt-feature-wrapper mt--20 ml_dec_20">
                            <div class="rbt-feature feature-style-2 rbt-radius">
                                <div class="icon bg-pink-opacity">
                                    <i class="feather-play-circle"></i>
                                </div>
                                <div class="feature-content">
                                    <h6 class="feature-title">{{'AvailabilityAndAccessibility' | translate}}</h6>
                                    <p class="feature-description">{{'allows' | translate}}</p>
                                </div>
                            </div>

                            <div class="rbt-feature feature-style-2 rbt-radius">
                                <div class="icon bg-primary-opacity">
                                    <i class="feather-book"></i>
                                </div>
                                <div class="feature-content">
                                    <h6 class="feature-title">{{'Diversity' | translate}}</h6>
                                    <p class="feature-description">{{'offers' | translate}}</p>
                                </div>
                            </div>

                            <div class="rbt-feature feature-style-2 rbt-radius">
                                <div class="icon bg-pink-opacity">
                                    <i class="feather-star"></i>
                                </div>
                                <div class="feature-content">
                                    <h6 class="feature-title">{{'quality' | translate}}</h6>
                                    <p class="feature-description">{{'concerned' | translate}}</p>
                                </div>
                            </div>

                            <div class="rbt-feature feature-style-2 rbt-radius">
                                <div class="icon bg-primary-opacity">
                                    <i class="feather-search"></i>
                                </div>
                                <div class="feature-content">
                                    <h6 class="feature-title">{{'Self-paced' | translate}}</h6>
                                    <p class="feature-description">{{'organize' | translate}}</p>
                                </div>
                            </div>
                            <div class="rbt-feature feature-style-2 rbt-radius">
                                <div class="icon bg-pink-opacity">
                                    <i class="feather-users"></i>
                                </div>
                                <div class="feature-content">
                                    <h6 class="feature-title">{{'support' | translate}}</h6>
                                    <p class="feature-description">{{'communicate' | translate}} 
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- End Feature List  -->
                        <div class="about-btn mt--40">
                            <a class="rbt-btn btn-gradient hover-transform-none" routerLink="/about-us">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text" routerLink="/about-us">{{'More About Us' | translate}}</span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End About Area  -->

    <br><br>
    <!-- Start Call To Action  -->
    <div class="rbt-callto-action-area mt_dec--half">
        <div class="container">
            <div class="row g-5">
                <div class="col-lg-6">
                    <div class="rbt-callto-action callto-action-default bg-color-white rbt-radius shadow-1">
                        <div class="row align-items-center">
                            <div class="col-lg-12 col-xl-5">
                                <div class="inner">
                                    <div class="rbt-category mb--20">
                                        <a href="https://www.learnyhome.com/Home" target="_blank">{{'learnyhome' | translate}}</a>
                                    </div>
                                    <h4 class="title mb--15">{{'seeAlso' | translate}}</h4>
                                    <p class="mb--15">{{'TheBestChoice' | translate}}</p>
                                </div>
                            </div>
                            <div class="col-lg-12 col-xl-7">
                                <div class="video-popup-wrapper mt_lg--10 mt_md--20 mt_sm--20">
                                    <img class="w-100 rbt-radius" src="assets/images/others/video-01.jpg"
                                        alt="Video Images">
                                    <a class="rbt-btn rounded-player-2 sm-size popup-video position-to-top with-animation"
                                        href="https://www.youtube.com/watch?v=LzyqG4-kZ0w" target="_blank">
                                        <span class="play-icon"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="rbt-callto-action callto-action-default bg-color-white rbt-radius shadow-1">
                        <div class="row align-items-center">
                            <div class="col-lg-12">
                                <div class="inner">
                                    <div class="rbt-category mb--20">
                                        <a style="cursor: default;">{{'HowToStart' | translate}}</a>
                                    </div>
                                    <h4 class="title mb--10">{{'paltformWorks' | translate}}
                                    </h4>
                                    <!-- <p class="mb--15">Top instructors from around the world</p> -->
                                    <div class="read-more-btn">
                                        <a class="rbt-btn btn-gradient btn-sm" routerLink="/about-us">
                                            <span>{{'CheckOut' | translate}}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Call To Action  -->

    <!-- Start Counterup Area  -->
    <div class="rbt-counterup-area rbt-section-gapBottom default-callto-action-overlap">
        <div class="container">
            <div class="row mb--60">
                <div class="col-lg-12">
                    <div class="section-title text-center">
                        <span class="subtitle bg-primary-opacity">{{'Why Choose Us' | translate}}</span>
                        <h2 class="title">{{'Creating A Community Of' | translate}} <br /> {{'Life Long Learners' | translate}}</h2>
                    </div>
                </div>
            </div>
            <div class="row g-5 hanger-line">
                <!-- Start Single Counter  -->
                <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div class="rbt-counterup rbt-hover-03 border-bottom-gradient">
                        <div class="top-circle-shape"></div>
                        <div class="inner">
                            <div class="rbt-round-icon">
                                <img src="assets/images/icons/counter-01.png" alt="Icons Images">
                            </div>
                            <div class="content">
                                <h3 class="counter">{{teacherCount}}</h3>
                                <span class="subtitle">{{'Teachers' | translate}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Single Counter  -->

                <!-- Start Single Counter  -->
                <div class="col-lg-3 col-md-6 col-sm-6 col-12 mt--60 mt_md--30 mt_sm--30 mt_mobile--60">
                    <div class="rbt-counterup rbt-hover-03 border-bottom-gradient">
                        <div class="top-circle-shape"></div>
                        <div class="inner">
                            <div class="rbt-round-icon">
                                <img src="assets/images/icons/counter-02.png" alt="Icons Images">
                            </div>
                            <div class="content">
                                <h3 class="counter">{{courseCount}}</h3>
                                <span class="subtitle">{{'Courses & Video' | translate}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Single Counter  -->

                <!-- Start Single Counter  -->
                <div class="col-lg-3 col-md-6 col-sm-6 col-12 mt_md--60 mt_sm--60">
                    <div class="rbt-counterup rbt-hover-03 border-bottom-gradient">
                        <div class="top-circle-shape"></div>
                        <div class="inner">
                            <div class="rbt-round-icon">
                                <img src="assets/images/icons/counter-03.png" alt="Icons Images">
                            </div>
                            <div class="content">
                                <h3 class="counter">{{studentCount}}</h3>
                                <span class="subtitle">{{'Student' | translate}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Single Counter  -->

                <!-- Start Single Counter  -->
                <div class="col-lg-3 col-md-6 col-sm-6 col-12 mt--60 mt_md--30 mt_sm--30 mt_mobile--60">
                    <div class="rbt-counterup rbt-hover-03 border-bottom-gradient">
                        <div class="top-circle-shape"></div>
                        <div class="inner">
                            <div class="rbt-round-icon">
                                <img src="assets/images/icons/counter-04.png" alt="Icons Images">
                            </div>
                            <div class="content">
                                <h3 class="counter">{{categoriesNo}}</h3>
                                <span class="subtitle">{{'cat' | translate}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Single Counter  -->
            </div>
        </div>
    </div>
    <!-- End Counterup Area  -->

    <!-- Start Testimonial Area   -->
    <!-- <div class="rbt-testimonial-area bg-color-white rbt-section-gap overflow-hidden" style="direction: ltr;">
        <div class="wrapper">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="section-title text-center mb--10">
                            <span class="subtitle bg-primary-opacity">EDUCATION FOR EVERYONE</span>
                            <h2 class="title">People like Learny Home education. <br /> No joking - here’s the proof!
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="scroll-animation-wrapper no-overlay mt--50">
            <div class="scroll-animation scroll-right-left">

                <div class="single-column-20 bg-theme-gradient-odd">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/facebook.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">After the launch, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-01.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Martha Maldonado, <span>CEO</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="single-column-20 bg-theme-gradient-odd">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/google.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">Learny Home education, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-02.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Michael D., <span>CEO</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="single-column-20 bg-theme-gradient-odd">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/yelp.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">Our educational, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-03.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Valerie J., <span>CEO</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="single-column-20 bg-theme-gradient-odd">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/facebook.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">People says about, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-04.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Hannah R., <span>CEO</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="single-column-20 bg-theme-gradient-odd">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/bing.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">Like this Learny Home, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-05.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Pearl B. Hill, <span>Marketing</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="single-column-20 bg-theme-gradient-odd">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/facebook.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">Educational template, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-01.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Mandy F. Wood, <span>SR Designer</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="single-column-20 bg-theme-gradient-odd">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/hubs.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">Online leaning, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-07.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Mildred W. Diaz, <span>Executive</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="single-column-20 bg-theme-gradient-odd">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/bing.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">Remote learning, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-08.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Christopher, <span>CEO</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="single-column-20 bg-theme-gradient-odd">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/yelp.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">University managemnet, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-06.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Fatima, <span>Child</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="scroll-animation-wrapper no-overlay mt--30">
            <div class="scroll-animation scroll-left-right">

                
                <div class="single-column-20 bg-theme-gradient-even">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/facebook.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">After the launch, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-01.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Martha Maldonado, <span>CEO</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               

                
                <div class="single-column-20 bg-theme-gradient-even">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/google.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">Learny Home education, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-02.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Michael D., <span>CEO</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               

                
                <div class="single-column-20 bg-theme-gradient-even">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/yelp.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">Our educational, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-03.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Valerie J., <span>CEO</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               

                
                <div class="single-column-20 bg-theme-gradient-even">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/bing.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">People says about, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-04.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Hannah R., <span>CEO</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
                
                <div class="single-column-20 bg-theme-gradient-even">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/hubs.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">Like this Learny Home, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-05.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Pearl B. Hill, <span>Marketing</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               

                
                <div class="single-column-20 bg-theme-gradient-even">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/yelp.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">Educational template, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-01.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Mandy F. Wood, <span>SR Designer</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               

                
                <div class="single-column-20 bg-theme-gradient-even">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/bing.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">Online leaning, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-07.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Mildred W. Diaz, <span>Executive</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               

                
                <div class="single-column-20 bg-theme-gradient-even">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/facebook.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">Remote learning, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-08.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Christopher, <span>CEO</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               

                
                <div class="single-column-20 bg-theme-gradient-even">
                    <div class="rbt-testimonial-box style-2">
                        <div class="inner">
                            <div class="icons">
                                <img src="assets/images/icons/yelp.png" alt="Clint Images">
                            </div>
                            <div class="description">
                                <p class="subtitle-3">University managemnet, vulputate at sapien sit amet,
                                    auctor iaculis lorem. In vel hend rerit nisi. Vestibulum eget risus velit.</p>
                                <div class="clint-info-wrapper">
                                    <div class="thumb">
                                        <img src="assets/images/testimonial/client-06.png" alt="Clint Images">
                                    </div>
                                    <div class="client-info">
                                        <h5 class="title">Fatima, <span>Child</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
    </div> -->
    <!-- End Testimonial Area   -->

    <!-- Start CallTo Action Area  -->
    <!-- <div class="rbt-call-to-action-area rbt-section-gap bg-gradient-7">
        <div class="rbt-callto-action rbt-cta-default style-6">
            <div class="container">
                <div class="row g-5 align-items-center content-wrapper">
                    <div class="col-xxl-3 col-xl-3 col-lg-6">
                        <div class="inner">
                            <div class="content text-start">
                                <h2 class="title color-white mb--0">Scholarship Programs</h2>
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-6 col-xl-6 col-lg-6">
                        <div class="inner-content text-start">
                            <p class="color-white">Apply for Admission in Post Graduate Diploma. Application Deadline:
                                26th September 2023 · Undergraduate & Graduate Admission: Fall 2023 Semester · 20%
                                Waiver on ...
                            </p>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-3 col-lg-6">
                        <div class="call-to-btn text-start text-xl-end">
                            <a class="rbt-btn btn-white hover-icon-reverse" >
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">LearnyHome Financial Aid</span>
                                    <span class="btn-icon"><i class="feather-arrow-right"></i></span>
                                    <span class="btn-icon"><i class="feather-arrow-right"></i></span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- End CallTo Action Area  -->
</section>
